<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top">
        <a routerLink="/home/vacations/drivers">
            <h3>Vacaciones chóferes /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ isEditMode ? (protocol.name || 'Editar protocolo') : 'Añadir protocolo' }}</h2>
            </div>
        </a>
    </div>
</div>

<form [formGroup]="protocolForm" class="content">
    <h4>Nombre del protocolo:</h4>
    <mat-form-field appearance="outline" id="title-form-field">
        <input type="text" matInput placeholder="Nombre del protocolo" formControlName="name">
        @if (protocolForm.get('name')?.invalid && protocolForm.get('name')?.touched) {
        <mat-error>
            El nombre es requerido
        </mat-error>
        }
    </mat-form-field>

    <h4>Código:</h4>
    <mat-form-field appearance="outline">
        <input type="text" matInput placeholder="Código del protocolo" formControlName="code">
        @if (protocolForm.get('code')?.invalid && protocolForm.get('code')?.touched) {
        <mat-error>
            El código es requerido
        </mat-error>
        }
    </mat-form-field>

    <h4>Descripción:</h4>
    <mat-form-field appearance="outline" id="area">
        <textarea matInput placeholder="Descripción del protocolo" formControlName="description" rows="5"></textarea>
        @if (protocolForm.get('description')?.invalid && protocolForm.get('description')?.touched) {
        <mat-error>
            La descripción es requerida
        </mat-error>
        }
    </mat-form-field>

    <div class="options-row">
        <mat-checkbox formControlName="enabled">Habilitado</mat-checkbox>
    </div>

    <br><br><br>
    <div class="buttons">
        <button mat-flat-button id="action" type="button" (click)="saveChanges()"
            [disabled]="isSubmitting || protocolForm.invalid">
            @if (isSubmitting) {
            {{ isEditMode ? 'Actualizando...' : 'Guardando...' }}
            } @else {
            {{ isEditMode ? 'Actualizar' : 'Guardar cambios' }}
            }
        </button>
        <button mat-flat-button id="cancel" type="button" (click)="cancel()">Cancelar</button>
    </div>
</form>
